import Input from "../../../../components/Input/Input"
import Button from "../../../../components/Button/Button"
import { validateEmail } from "../../../../helpers/validationEmail"
import { editNewLeadDetails, emailBankAccount } from "../../../../features/contacts/contacts"
import { showSnackBar } from "../../../../components/Snackbar/Snackbar"
import { useDispatch } from "react-redux"
import { createBankAccountLink } from "../../../../features/bankAccountLink/bankAccountLink"
import { useMyContextLoading } from "../../../../components/LoadingContextProvider/LoadingContextProvider"
import { acceptsAch } from "../../../../constants/paymentMethods"

export const SendEmail = ({ userId, isBillingAccount, isSignedMainDoc, confirmEmail, setConfirmEmail, userRole, lsaTemplateType, signingBlocked, blockedHint, acceptedPaymentMethods, stopOnSendError = false }) => {

  const { triggerLoading } = useMyContextLoading()

  const cardOnly = !acceptsAch(acceptedPaymentMethods)
  const clientProvides = cardOnly ? 'payment details' : 'bank information'
  const repEnters = cardOnly ? 'payment details' : 'bank details'
  const clientAdds = cardOnly ? 'payment details' : 'bank account'

  const dispatch = useDispatch()

  const handleSendEmail = async () => {
    const response = await dispatch(emailBankAccount({ email: confirmEmail, userId, lsaTemplateType }))
    if (response.error && stopOnSendError) {
      showSnackBar("error", typeof response.payload === 'string' ? response.payload : "Something went wrong")
      triggerLoading(false)
      return
    }
    if (response.error) {
      showSnackBar("error", "Something went wrong")
    }
    triggerLoading(false)
    showSnackBar("success", "Email successfully sent")

  }

  const handleCreateLink = async () => {
    triggerLoading(true)
    const response = await dispatch(createBankAccountLink(userId))
    if (response.error) {
      showSnackBar("error", "Something went wrong")
      triggerLoading(false)
    } else {
      await handleSendEmail()
    }
  }

  const updatePaymentSchedule = async () => {
    const postData = {
      bankConfirmationEmail: confirmEmail
    }
    try {
      const response = await dispatch(editNewLeadDetails({ userId, data: postData }))
      if (response.error) {
      } else {
        showSnackBar("success", "Contact successfully updated")
      }
    } catch (error) {
    }
  }

  return (
    <>
      <div>
        <div className="bg-background p-6 rounded-2xl">
          {
            (userRole === 'customer' || userRole === 'user') ?
              `You can either send the URL via email so the customer can provide their ${clientProvides} and confirm the
          agreement, or you can enter the ${repEnters} manually. Once the payment method is set up, you’ll be able to
          upload the LSA document manually.`
              : ` The last step is to send the customer a url to add their ${clientAdds} and confirm the agreement. Send the url
          via email below:`
          }
        </div>
        <div className="pt-[24px]">
          <Input
            disabled={isSignedMainDoc}
            type="email"
            value={confirmEmail}
            onChange={(e) => setConfirmEmail(e.target.value)}
            placeholder="Enter Email"
            label="Confirm email address"
          />
        </div>
      </div>
      {(
        <div className="mt-6 mb-6 flex flex-col items-end space-y-2">
          {signingBlocked && !isSignedMainDoc && (
            <div className="text-sm text-text-secondary">
              {blockedHint || 'No enrolled debts — complete Credit Select first.'}
            </div>
          )}
          <Button
            disabled={isSignedMainDoc || !validateEmail(confirmEmail) || signingBlocked}
            width="min-w-[156px]"
            onClick={() => {
              isBillingAccount ? handleSendEmail() : handleCreateLink()
              updatePaymentSchedule()
            }}
          >
            {"Send email"}
          </Button>
        </div>
      )
      }
    </>
  )
}
